import { render, staticRenderFns } from "./DisposeServiceDialog.vue?vue&type=template&id=9b6c2090&scoped=true&"
import script from "./DisposeServiceDialog.vue?vue&type=script&lang=js&"
export * from "./DisposeServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisposeServiceDialog.vue?vue&type=style&index=0&id=9b6c2090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c2090",
  null
  
)

export default component.exports